import { AnyGeoEvent } from 'features/geoEvents/anyGeoEvent.types';
import { isEditGeoEventDisabled, usePermissions } from 'hooks/usePermissions';
import { useAuthState } from 'state/useAuthState';
import { getHasEditRole } from './useCanEditGeoEvent.utils';

type UseCanEditGeoEvent = {
  hasEditRole: boolean;
  canEditGeoEvent: boolean;
  isLoading: boolean;
};

export const useCanEditGeoEvent = (
  geoEvent: AnyGeoEvent | undefined,
): UseCanEditGeoEvent => {
  const { permissions } = useAuthState();
  const { data: permissionsData, isLoading } = usePermissions({
    geoEventId: geoEvent?.id,
    geoEventType: geoEvent?.geoEventType,
  });

  if (!geoEvent) {
    return { hasEditRole: false, canEditGeoEvent: false, isLoading };
  }

  const hasEditRole = getHasEditRole(geoEvent, permissions);

  return {
    hasEditRole,
    canEditGeoEvent:
      hasEditRole &&
      !isLoading &&
      !isEditGeoEventDisabled(geoEvent.geoEventType, permissionsData),
    isLoading,
  };
};
